import {Component, EventEmitter, Input, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {TOAST_TYPE} from "../../../constants/Tpiq.constants";
import {FileUploader, FileUploaderOptions, FileUploadModule} from "ng2-file-upload";
import {Session} from "../../../services/Session";
import {takeUntil} from "rxjs/operators";
import {ToastService} from "../../../services/Toast.service";
import {SwitchBoard} from "../../../services/SwitchBoard";
import {LoadingService} from "../../../services/LoadingService";
import {StateService} from "../../../services/StateService";
import {ActivatedRoute, Router} from "@angular/router";
import {PageTitleService} from "../../../services/PageTitle";
import {TaxPlanningService} from "../../../tpiq-services/tax-planning.service";
import {ManageTaxStrategiesServices} from "../../../tpiq-services/manage-tax-strategies.service";
import {v4 as uuid} from 'uuid';
import {State} from "../../../models/State";
import {CreateOrUpdateStrategyComponent} from "../create-or-update-strategy/create-or-update-strategy.component";
import {TaxStrategyOverviewComponent} from "../tax-strategy-overview/tax-strategy-overview.component";
import {TaxStrategyInternalComponent} from "../tax-strategy-internal/tax-strategy-internal.component";
import {TaxStrategyResourcesComponent} from "../tax-strategy-resources/tax-strategy-resources.component";
import {TaxStrategyTasksComponent} from "../tax-strategy-tasks/tax-strategy-tasks.component";
import {TemplatesListComponent} from "../../templates/templates-list/templates-list.component";
import {StrategyPreferredVendorsComponent} from "../strategy-preferred-vendors/strategy-preferred-vendors.component";
import {FoundationInit} from "../../../directives/foundation.directive";
import { environment } from '../../../../environments/environment';

declare const _: any;
declare let jQuery: any;

@Component({
  selector: 'app-view-tax-strategy',
  standalone: true,
  imports: [CommonModule, FormsModule, CreateOrUpdateStrategyComponent, TaxStrategyOverviewComponent, TaxStrategyInternalComponent,
  TaxStrategyResourcesComponent, TaxStrategyTasksComponent, TemplatesListComponent, StrategyPreferredVendorsComponent, FileUploadModule,
  FoundationInit],
  templateUrl: './view-tax-strategy.component.html',
  styleUrl: './view-tax-strategy.component.scss'
})
export class ViewTaxStrategyComponent implements OnInit, OnDestroy {
  org: string =  Session.getOrg();
  user: string = Session.getUser().id;
  taxStrategyId: string;
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  editorOptions = {
    linkAlwaysBlank: true,
    heightMin: 100,
    heightMax: 100,
    toolbarButtons: ['bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'color', 'insertLink', 'outdent', 'indent'],
    toolbarSticky: true,
    toolbarVisibleWithoutSelection: false,
    toolbarInline: true,
    fontFamilyDefaultSelection: 'poppins',
    fontFamily: {'Poppins-Regular': 'poppins'},
    fontFamilySelection: true,
    placeholderText: 'Notes about this strategy',
    charCounterCount: false,
    colorsText: ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'],
    events : {},
    key: environment.froalaKey,
    imageUploadParam: 'file',
    // Set the image upload URL.
    imageUploadURL: `https://services.taxplaniq.com/DocumentServices/orgs/${this.org}/users/${this.user}/document`,

    // Additional upload params.
    imageUploadParams: {payload: JSON.stringify({})},

    // Set request type.
    imageUploadMethod: 'POST',

    // Set max image size to 5MB.
    imageMaxSize: 5 * 1024 * 1024,

    // Allow to upload PNG and JPG.
    imageAllowedTypes: ['jpeg', 'jpg', 'png'],
  };
  stratagiesTypes: Array<any> = [];
  recurringTypes: Array<any> = [{key: 'Never', value: 'Never'}, {key: 'Yearly', value: 'Yearly'}];
  applicableTo: Array<any> = [{key: 'Business', value: 'Business'}, {key: 'Individual', value: 'Individual'}, {key: 'Both', value: 'Both'}];
  complexity: Array<any> = [
    {key: '1', value: '1'},
    {key: '2', value: '2'},
    {key: '3', value: '3'},
    {key: '4', value: '4'},
    {key: '5', value: '5'}
  ];
  associatedWith: Array<any> = [
    {id: 'a627ccde-dd57-1090-cefa-fc965526a557', name: 'Effective Rate'},
    {id: '82c36191-8d6f-39e7-f711-947591551608', name: 'Marginal Rate'},
    {id: '5a314bc1-4534-0426-1db4-d18403485072', name: 'Cap Gain Rate'},
    {id: '23a5e1b2-03cf-6675-2596-0952387d4b46', name: 'C Corp Flat Rate'},
    {id: '393a6f91-8222-11ef-bd9d-12ff30f54e53', name: 'Full Credit'},
    {id: '454ba189-8222-11ef-bd9d-12ff30f54e53', name: 'N/A'},
    {id: 'f637945b-e78e-11ef-a4a7-0e0adc17208f', name: 'Market Growth Rate'},
    {id: 'ce08f4de-b7f2-449c-9bf8-9674fbf6d0d5', name: 'Qualified Dividends'}];
  stateAssociatedWith: Array<any> = [
    {id: 'fba5d8f4-c3f3-46db-aaf4-df85b1945ad3', name: 'State Individual Rate'},
    {id: '454ba189-8222-11ef-bd9d-12ff30f54e53', name: 'N/A'},
    {id: 'e955c67d-ecb3-45e3-9163-3f42f43991a6', name: 'State Corporate Rate'}
  ];
  taxStrategy: any = {
    rules: {
      formula: '',
      planAmountFormula: '',
      whyDescription: '',
      fieldDescription: '',
      aiQJsonField: '',
      aiQCategory: '',
      aiQGate: '',
      aiQGateTitle: '',
      aiQDiscoveryQuestion: '',
      aiQMinRisk: ''
    },
    investmentDescription: '',
    resources: {
      files: [],
      links: '',
      videos: [{
        id: '',
        name: ''
      }]
    },
    firmCustomizations: {
      files: [],
      content: ''
    },
    clientResourceFiles: []
  };
  hasData: boolean;
  updateTypes =  {name: false, type: false, updateName: false, associatedWith: false, recurring: false, desc: false};
  checklist: Array<any> = [];
  isEditable = false;
  rulesEditBackup: any;
  originalTaxStrategy: any;
  mode: string;
  linkEditorOptions: any = {
    linkAlwaysBlank: true,
    heightMin: 100,
    heightMax: 200,
    toolbarButtons: ['bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'color', 'insertLink', 'outdent', 'indent'],
    toolbarSticky: true,
    toolbarVisibleWithoutSelection: false,
    toolbarInline: true,
    fontFamilyDefaultSelection: 'poppins',
    fontFamily: {'Poppins-Regular': 'poppins'},
    fontFamilySelection: true,
    placeholderText: 'Links',
    charCounterCount: false,
    colorsText: ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'],
    events : {},
    key: environment.froalaKey,
    imageUploadParam: 'file',
    // Set the image upload URL.
    imageUploadURL: `https://services.taxplaniq.com/DocumentServices/orgs/${this.org}/users/${this.user}/document`,

    // Additional upload params.
    imageUploadParams: {payload: JSON.stringify({})},

    // Set request type.
    imageUploadMethod: 'POST',

    // Set max image size to 5MB.
    imageMaxSize: 5 * 1024 * 1024,

    // Allow to upload PNG and JPG.
    imageAllowedTypes: ['jpeg', 'jpg', 'png'],
  };
  checklistDescEditorOptions: any = {
    linkAlwaysBlank: true,
    heightMin: 100,
    heightMax: 200,
    toolbarButtons: ['bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'color', 'insertLink', 'outdent', 'indent'],
    toolbarSticky: true,
    toolbarVisibleWithoutSelection: false,
    toolbarInline: true,
    fontFamilyDefaultSelection: 'poppins',
    fontFamily: {'Poppins-Regular': 'poppins'},
    fontFamilySelection: true,
    placeholderText: 'Describe this checklist item',
    charCounterCount: false,
    colorsText: ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'],
    events : {},
    key: environment.froalaKey,
    imageUploadParam: 'file',
    // Set the image upload URL.
    imageUploadURL: `https://services.taxplaniq.com/DocumentServices/orgs/${this.org}/users/${this.user}/document`,

    // Additional upload params.
    imageUploadParams: {payload: JSON.stringify({})},

    // Set request type.
    imageUploadMethod: 'POST',

    // Set max image size to 5MB.
    imageMaxSize: 5 * 1024 * 1024,

    // Allow to upload PNG and JPG.
    imageAllowedTypes: ['jpeg', 'jpg', 'png'],
  };
  checklistObj: any = {};
  uploader: FileUploader;
  videoUploader: FileUploader;
  hasBaseDropZoneOver = false;
  hasBaseVideoDropZoneOver = false;
  newStrategyId: string;
  showEdit = true;
  groupId = '';
  setUpChecklistsGroupId = '';
  recurringChecklistsGroupId = '';
  eligibilityCriteriaChecklistsGroupId = '';
  tempCustomRates: Array<any> = [];
  currentView = 'overview';
  displayType: string;
  isRulesEnabled: boolean = false;
  aiQRiskLevels: Array<any> = [
    { key: '1 - Minimal', value: 'Sustained' },
    { key: '2 - Low', value: 'More Likely Than Not' },
    { key: '3 - Moderate', value: 'Substantial Authority' },
    { key: '4 - Heightened', value: 'Reasonable Basis' },
    { key: '5 - Significant', value: 'Listed/Reportable' }
  ];
  preferredVendorsEditorOptions: any = {
    linkAlwaysBlank: true,
    heightMin: 100,
    heightMax: 200,
    toolbarButtons: ['bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'color', 'insertLink', 'outdent', 'indent'],
    toolbarSticky: true,
    toolbarVisibleWithoutSelection: false,
    toolbarInline: true,
    fontFamilyDefaultSelection: 'poppins',
    fontFamily: {'Poppins-Regular': 'poppins'},
    fontFamilySelection: true,
    placeholderText: 'Preferred Vendors',
    charCounterCount: false,
    colorsText: ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'],
    events : {},
    key: environment.froalaKey,
    imageUploadParam: 'file',
    // Set the image upload URL.
    imageUploadURL: `https://services.taxplaniq.com/DocumentServices/orgs/${this.org}/users/${this.user}/document`,

    // Additional upload params.
    imageUploadParams: {payload: JSON.stringify({})},

    // Set request type.
    imageUploadMethod: 'POST',

    // Set max image size to 5MB.
    imageMaxSize: 5 * 1024 * 1024,

    // Allow to upload PNG and JPG.
    imageAllowedTypes: ['jpeg', 'jpg', 'png'],
  };
  clientOverviewEditorOptions: any = {
    heightMin: 100,
    heightMax: 200,
    linkAlwaysBlank: true,
    toolbarButtons: ['bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'color', 'insertLink', 'outdent', 'indent'],
    toolbarSticky: true,
    toolbarVisibleWithoutSelection: false,
    toolbarInline: true,
    fontFamilyDefaultSelection: 'poppins',
    fontFamily: {'Poppins-Regular': 'poppins'},
    fontFamilySelection: true,
    placeholderText: 'Client Overview',
    charCounterCount: false,
    colorsText: ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'],
    events : {},
    key: environment.froalaKey,
    imageUploadParam: 'file',
    // Set the image upload URL.
    imageUploadURL: `https://services.taxplaniq.com/DocumentServices/orgs/${this.org}/users/${this.user}/document`,

    // Additional upload params.
    imageUploadParams: {payload: JSON.stringify({})},

    // Set request type.
    imageUploadMethod: 'POST',

    // Set max image size to 5MB.
    imageMaxSize: 5 * 1024 * 1024,

    // Allow to upload PNG and JPG.
    imageAllowedTypes: ['jpeg', 'jpg', 'png']
  };

  clientTodoEditorOptions: any = {
    heightMin: 100,
    heightMax: 100,
    linkAlwaysBlank: true,
    toolbarButtons: ['bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'color', 'insertLink', 'outdent', 'indent'],
    toolbarSticky: true,
    toolbarVisibleWithoutSelection: false,
    toolbarInline: true,
    fontFamilyDefaultSelection: 'poppins',
    fontFamily: {'Poppins-Regular': 'poppins'},
    fontFamilySelection: true,
    placeholderText: 'Todo Description',
    charCounterCount: false,
    colorsText: ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'],
    events : {},
    key: environment.froalaKey,
    imageUploadParam: 'file',
    // Set the image upload URL.
    imageUploadURL: `https://services.taxplaniq.com/DocumentServices/orgs/${this.org}/users/${this.user}/document`,

    // Additional upload params.
    imageUploadParams: {payload: JSON.stringify({})},

    // Set request type.
    imageUploadMethod: 'POST',

    // Set max image size to 5MB.
    imageMaxSize: 5 * 1024 * 1024,

    // Allow to upload PNG and JPG.
    imageAllowedTypes: ['jpeg', 'jpg', 'png']
  };
  firmCustomizationEditorOptions: any = {
    heightMin: 100,
    heightMax: 100,
    linkAlwaysBlank: true,
    toolbarButtons: ['bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'color', 'insertLink', 'outdent', 'indent'],
    toolbarSticky: true,
    toolbarVisibleWithoutSelection: false,
    toolbarInline: true,
    fontFamilyDefaultSelection: 'poppins',
    fontFamily: {'Poppins-Regular': 'poppins'},
    fontFamilySelection: true,
    placeholderText: 'Content',
    charCounterCount: false,
    colorsText: ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'],
    events : {},
    key: environment.froalaKey,
    imageUploadParam: 'file',
    // Set the image upload URL.
    imageUploadURL: `https://services.taxplaniq.com/DocumentServices/orgs/${this.org}/users/${this.user}/document`,

    // Additional upload params.
    imageUploadParams: {payload: JSON.stringify({})},

    // Set request type.
    imageUploadMethod: 'POST',

    // Set max image size to 5MB.
    imageMaxSize: 5 * 1024 * 1024,

    // Allow to upload PNG and JPG.
    imageAllowedTypes: ['jpeg', 'jpg', 'png']
  };
  @Input() parentStrategyId: any;
  reveal: any = {
    editStrategy: false,
    suggestion: false
  };
  isCustomRateEdit = false;
  fixedRatesArray: Array<any> = [
    {id: 'a627ccde-dd57-1090-cefa-fc965526a557', name: 'Effective Rate', rate: '24'},
    {id: '82c36191-8d6f-39e7-f711-947591551608', name: 'Marginal Rate', rate: '24'},
    {id: '5a314bc1-4534-0426-1db4-d18403485072', name: 'Cap Gain Rate', rate: '24'},
    {id: '23a5e1b2-03cf-6675-2596-0952387d4b46', name: 'C Corp Flat Rate', rate: '24'},
    {id: 'ca57f1ef-ebb8-d007-66f5-59a3297f0502', name: 'SE Tax Rate', rate: '15.3'}];
  tempCustomRateObject: any = {
    id : '',
    name : '',
    rate : 0,
    formula: {
      displayValue: '',
      actualValue: '',
      displayValuesArray: [],
      actualValuesArray: []
    }
  };
  indexOfTempCustomRateObject: any;
  clientResourcesEditorOptions: any = {
    heightMin: 100,
    heightMax: 200,
    linkAlwaysBlank: true,
    toolbarButtons: ['bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'color', 'insertLink', 'outdent', 'indent'],
    toolbarSticky: true,
    toolbarVisibleWithoutSelection: false,
    toolbarInline: true,
    fontFamilyDefaultSelection: 'poppins',
    fontFamily: {'Poppins-Regular': 'poppins'},
    fontFamilySelection: true,
    placeholderText: 'Client Resources',
    charCounterCount: false,
    colorsText: ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'],
    events : {},
    key: environment.froalaKey,
    imageUploadParam: 'file',
    // Set the image upload URL.
    imageUploadURL: `https://services.taxplaniq.com/DocumentServices/orgs/${this.org}/users/${this.user}/document`,

    // Additional upload params.
    imageUploadParams: {payload: JSON.stringify({})},

    // Set request type.
    imageUploadMethod: 'POST',

    // Set max image size to 5MB.
    imageMaxSize: 5 * 1024 * 1024,

    // Allow to upload PNG and JPG.
    imageAllowedTypes: ['jpeg', 'jpg', 'png']
  };
  recurringChecklists: Array<any> = [];
  tagsList: Array<any> = [];
  isNewTagAdd: boolean = false;
  tagName: string = '';
  selectedTagValues: Array<any> = [];
  displayTags = true;
  deadlineDescriptionEditorOptions: any = {
    heightMin: 50,
    heightMax: 100,
    linkAlwaysBlank: true,
    toolbarButtons: ['bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'color', 'insertLink', 'outdent', 'indent'],
    toolbarSticky: true,
    toolbarVisibleWithoutSelection: false,
    toolbarInline: true,
    fontFamilyDefaultSelection: 'poppins',
    fontFamily: {'Poppins-Regular': 'poppins'},
    fontFamilySelection: true,
    placeholderText: 'Deadline Description',
    charCounterCount: false,
    colorsText: ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'],
    events : {},
    key: environment.froalaKey,
    imageUploadParam: 'file',
    // Set the image upload URL.
    imageUploadURL: `https://services.taxplaniq.com/DocumentServices/orgs/${this.org}/users/${this.user}/document`,

    // Additional upload params.
    imageUploadParams: {payload: JSON.stringify({})},

    // Set request type.
    imageUploadMethod: 'POST',

    // Set max image size to 5MB.
    imageMaxSize: 5 * 1024 * 1024,

    // Allow to upload PNG and JPG.
    imageAllowedTypes: ['jpeg', 'jpg', 'png']
  };
  showTemplates:boolean = false;

  currentSection = 'overview';
  isNewSetupChecklist: boolean = false;
  isNewRecurringChecklist: boolean = false;
  setupChecklistName = '';
  setupChecklistDescription = '';
  recurringChecklistName = '';
  recurringChecklistDescription = '';
  showVendors:boolean = false;
  @Input() strategyId: any;
  @Input() viewOnly: any;

  constructor(
    private toastService: ToastService,
    private switchBoard: SwitchBoard,
    private loadingService: LoadingService,
    private stateService: StateService,
    private _router: Router,
    private _route: ActivatedRoute,
    private titleService: PageTitleService,
    private taxPlanningService: TaxPlanningService,
    private taxStrategyServices: ManageTaxStrategiesServices
  ) {}

  ngOnInit() {
    this._init();
  }

  _init() {
    const base = this;
    this.org = Session.getOrg();
    this.user = Session.getUser().id;
    this.isRulesEnabled = ['stag-taxplaniq', 'trialtaxplaniq'].includes(this.org);
    this.getFirmTagsForStrategy();
    this.switchBoard.onClickPrev
      .pipe(takeUntil(this.destroy$)).subscribe(title => {
      this.gotoDefaultPage();
    });

    this.switchBoard.onToastConfirm.pipe(takeUntil(this.destroy$)).subscribe(toast => {
      if (toast && toast.data && toast.data.id){
        const index = _.findIndex(this.taxStrategy.customTaxRates, {id: toast.data.id});
        this.taxStrategy.customTaxRates.splice(index, 1);
      }
    });

    this._route.params.pipe(takeUntil(this.destroy$)).subscribe(params => {
      if (params.strategyId){
        this.taxStrategyId = params.strategyId;
        if (params.action && params.action == 'resources') {
          this.currentView = 'resources';
        } else if (params.action && params.action == 'vendors') {
          this.currentView = 'vendors';
        } else if (params.action && params.action == 'rules' && !this.isRulesEnabled) {
          this.currentView = 'overview';
        }
        this.switchPage(this.currentView);
        this.getTaxStragegyData();
      } else if (this.strategyId) {
        this.taxStrategyId = this.strategyId;
        this.switchPage(this.currentView);
        this.getTaxStragegyData();
      }
    });

  }

  getFirmTagsForStrategy() {
    this.taxStrategyServices.getTagsDataForFirm(this.org, this.user)
      .subscribe(response => {
        this.tagsList = response || [];
      }, error => {
      });
  }

  switchPage(view){
    const base = this;
    if (view === 'rules' && !this.isRulesEnabled) {
      this.currentView = 'overview';
    } else {
      this.currentView = view;
    }
    jQuery('#a-overview').attr('aria-selected', 'false');
    jQuery('#a-internal').attr('aria-selected', 'false');
    jQuery('#a-rules').attr('aria-selected', 'false');
    jQuery('#a-opportunities').attr('aria-selected', 'false');
    jQuery('#a-risks').attr('aria-selected', 'false');
    jQuery('#a-resources').attr('aria-selected', 'false');
    jQuery('#a-tasks').attr('aria-selected', 'false');
    jQuery('#a-templates').attr('aria-selected', 'false');
    jQuery('#a-vendors').attr('aria-selected', 'false');
    jQuery('#a-' + view).attr('aria-selected', 'true');
    if (view == 'templates') {
      this.mode = 'edit';
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  gotoDefaultPage() {
    const prevState = this.stateService.getPrevState();
    if (prevState) {
      this.stateService.pop();
      this._router.navigate([prevState.url]);
    }
  }

  getTaxStragegyData() {
    const base = this;
    this.loadingService.triggerLoadingEvent(true);
    this.taxStrategyServices.getTaxStrategyId(this.org, this.user, this.taxStrategyId).subscribe(response => {
      this.hasData = true;
      this.stratagiesTypes = response.strategyTypes;
      this.taxStrategy = response.strategy;
      this.taxStrategy.urgency = this.normalizeEnumValue(this.taxStrategy.urgency);
      this.taxStrategy.burden = this.normalizeEnumValue(this.taxStrategy.burden);
    this.taxStrategy.investmentDescription = this.taxStrategy.investmentDescription || '';
      this.ensureRules();
      this.showTemplates = true;
      this.showVendors = true;
      this.selectedTagValues = this.taxStrategy.tags || [];
      if (!this.taxStrategy.hasOwnProperty('clientOverview')) {
        this.taxStrategy.clientOverview = '';
      }
      if (!this.taxStrategy.hasOwnProperty('preferredVendors')) {
        this.taxStrategy.preferredVendors = '';
      }
      if (!this.taxStrategy.hasOwnProperty('clientTodos')) {
        this.taxStrategy.clientTodos = [];
      }
      if (!this.taxStrategy.hasOwnProperty('firmCustomizations')) {
        this.taxStrategy.firmCustomizations = {
          files: [],
          content: ''
        };
      }
      if (!this.taxStrategy.resources.hasOwnProperty('videos')) {
        this.taxStrategy.resources['videos'] = [];
      }
      if (!this.taxStrategy.hasOwnProperty('clientResourceFiles')) {
        this.taxStrategy.clientResourceFiles = [];
      }
      this.taxStrategy.opportunities = this.taxStrategy.opportunities || [];
      this.taxStrategy.potentialRisks = this.taxStrategy.potentialRisks || [];
      this.taxStrategy.clientTodos = this.taxStrategy.clientTodos || [];
      this.taxStrategy.customTaxRates = this.taxStrategy.customTaxRates || [];
      _.each(this.taxStrategy.customTaxRates, function(customTaxRate){
        try{
          customTaxRate.formula = JSON.parse(customTaxRate.formula);
        }catch (e){}
      });
      this.populateValues();
      this.hasData = true;
      this.originalTaxStrategy = _.cloneDeep(this.taxStrategy);
      this.titleService.setPageTitle(this.taxStrategy.name);
      if (this.taxStrategy.clientResourceFiles.length > 0) {
        _.each(this.taxStrategy.clientResourceFiles, (file) => {
          const splitArray = file.name.split('.');
          if (base.isImage(splitArray[splitArray.length - 1])) {
            base.getFileData(file, true);
          }
        });
      }
      if (this.taxStrategy.resources.files.length > 0) {
        _.each(this.taxStrategy.resources.files, (file) => {
          const splitArray = file.name.split('.');
          if (base.isImage(splitArray[splitArray.length - 1])) {
            base.getFileData(file, true);
          }
        });
      }
      if (this.taxStrategy.firmCustomizations.files.length > 0) {
        _.each(this.taxStrategy.firmCustomizations.files, (file) => {
          const splitArray = file.name.split('.');
          if (base.isImage(splitArray[splitArray.length - 1])) {
            base.getFileData(file, true);
          }
        });
      }

      this.loadingService.triggerLoadingEvent(false);
    }, error => {
      this.loadingService.triggerLoadingEvent(false);
    });
  }

  enableEdit() {
    this.isEditable = true;
    this.rulesEditBackup = _.cloneDeep(this.taxStrategy.rules);
  }

  cancelEdit() {
    if (!this.isEditable) {
      return;
    }
    this.taxStrategy.rules = _.cloneDeep(this.rulesEditBackup);
    this.isEditable = false;
  }

  saveRules() {
    this.loadingService.triggerLoadingEvent(true);
    const {
      formula,
      planAmountFormula,
      whyDescription,
      fieldDescription,
      aiQJsonField,
      aiQCategory,
      aiQGate,
      aiQGateTitle,
      aiQDiscoveryQuestion,
      aiQMinRisk
    } = this.taxStrategy.rules || {};
    const payload = {
      id: this.taxStrategy.id,
      name: this.taxStrategy.name,
      formula,
      planAmountFormula,
      whyDescription,
      fieldDescription,
      aiQJsonField,
      aiQCategory,
      aiQGate,
      aiQGateTitle,
      aiQDiscoveryQuestion,
      aiQMinRisk
    };
    this.taxStrategyServices.saveStrategyRule(this.org, this.user, this.taxStrategy.id, payload)
      .subscribe(() => {
        this.taxStrategy.type = this.taxStrategy.rules?.aiQCategory || this.taxStrategy.type;
        this.taxStrategy.riskLevel = this.taxStrategy.rules?.aiQMinRisk || this.taxStrategy.riskLevel;
        this.loadingService.triggerLoadingEvent(false);
        this.isEditable = false;
        this.rulesEditBackup = _.cloneDeep(this.taxStrategy.rules);
        this.toastService.pop(TOAST_TYPE.success, 'Rules updated');
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.handleError(error);
      });
  }

  private ensureRules() {
    if (Array.isArray(this.taxStrategy.rules)) {
      const firstRule = this.taxStrategy.rules[0] || {};
      this.taxStrategy.rules = {
        formula: firstRule.formula || '',
        planAmountFormula: firstRule.planAmountFormula || '',
        whyDescription: firstRule.whyDescription || '',
        fieldDescription: firstRule.fieldDescription || '',
        aiQJsonField: firstRule.aiQJsonField || '',
        aiQCategory: firstRule.aiQCategory || this.taxStrategy.type || '',
        aiQGate: firstRule.aiQGate || '',
        aiQGateTitle: firstRule.aiQGateTitle || '',
        aiQDiscoveryQuestion: firstRule.aiQDiscoveryQuestion || '',
        aiQMinRisk: firstRule.aiQMinRisk || this.taxStrategy.riskLevel || ''
      };
      return;
    }

    if (!this.taxStrategy.rules) {
      this.taxStrategy.rules = {
        formula: '',
        planAmountFormula: '',
        whyDescription: '',
        fieldDescription: '',
        aiQJsonField: '',
        aiQCategory: this.taxStrategy.type || '',
        aiQGate: '',
        aiQGateTitle: '',
        aiQDiscoveryQuestion: '',
        aiQMinRisk: this.taxStrategy.riskLevel || ''
      };
    } else {
      this.taxStrategy.rules.formula = this.taxStrategy.rules.formula || '';
      this.taxStrategy.rules.planAmountFormula = this.taxStrategy.rules.planAmountFormula || '';
      this.taxStrategy.rules.whyDescription = this.taxStrategy.rules.whyDescription || '';
      this.taxStrategy.rules.fieldDescription = this.taxStrategy.rules.fieldDescription || '';
      this.taxStrategy.rules.aiQJsonField = this.taxStrategy.rules.aiQJsonField || '';
      this.taxStrategy.rules.aiQCategory = this.taxStrategy.rules.aiQCategory || this.taxStrategy.type || '';
      this.taxStrategy.rules.aiQGate = this.taxStrategy.rules.aiQGate || '';
      this.taxStrategy.rules.aiQGateTitle = this.taxStrategy.rules.aiQGateTitle || '';
      this.taxStrategy.rules.aiQDiscoveryQuestion = this.taxStrategy.rules.aiQDiscoveryQuestion || '';
      this.taxStrategy.rules.aiQMinRisk = this.taxStrategy.rules.aiQMinRisk || this.taxStrategy.riskLevel || '';
    }
  }

  isImage(extension){
    const imageTypes = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
    if (imageTypes.indexOf(extension.toLowerCase()) != -1) {
      return true;
    }else {
      return false;
    }
  }

  populateValues(){
    if (this.taxStrategy.customTaxRates.length > 0){
      this.associatedWith = this.associatedWith.concat(this.taxStrategy.customTaxRates);
      this.associatedWith = [...this.associatedWith];
    }

    let associatedWith = _.find(this.associatedWith, {'id': this.taxStrategy.associatedWith});
    if (associatedWith){
      this.taxStrategy.associatedField = associatedWith ? associatedWith.name : '';
    } else if (this.taxStrategy.customTaxRates && this.taxStrategy.customTaxRates.length > 0){
      this.taxStrategy.associatedField = ` ${this.taxStrategy.customTaxRates[0].name} - ${this.taxStrategy.customTaxRates[0].rate}% (Custom rate)`;
    }

    const stateAssociatedWith = _.find(this.stateAssociatedWith, {'id': this.taxStrategy.stateAssociatedWith});
    this.taxStrategy.stateAssociatedField = stateAssociatedWith ? stateAssociatedWith.name : '';

    this.populateChecklistData();
    if (!_.isEmpty(this.taxStrategy.strategyChecklist)) {
      this.groupId = this.taxStrategy.strategyChecklist.groupId ? this.taxStrategy.strategyChecklist.groupId : '';
    }
  }

  populateChecklistData() {
    const base = this;
    if (this.taxStrategy.strategyChecklist.sections && this.taxStrategy.strategyChecklist.sections.length > 0) {
      _.each(this.taxStrategy.strategyChecklist.sections, function(obj){
        if (obj.name == 'Setup') {
          base.checklist = obj.checklists;
          base.setUpChecklistsGroupId = obj.id;
        } else if (obj.name == 'Recurring') {
          base.recurringChecklists = obj.checklists;
          base.recurringChecklistsGroupId = obj.id;
        } else if (obj.name == 'Eligibility Criteria') {
          base.eligibilityCriteriaChecklistsGroupId = obj.id;
        }
      });
    }
  }

  handleError(error) {
    this.loadingService.triggerLoadingEvent(false);
    error = JSON.parse(error);
    const message = error.message ? error.message : `Failed To Perform Operation`;
    try {
      this.toastService.pop(TOAST_TYPE.error, message);
    } catch (e) {
      this.toastService.pop(TOAST_TYPE.error, message);
    }
  }

  updateColumn(type, value ) {
    this.updateTypes[type] = value;
  }

  getFileData(file, isForVisualImage?){
    this.loadingService.triggerLoadingEvent(true);
    this.taxStrategyServices.downloadDocument(this.user, this.org, file.id)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        if (isForVisualImage) {
          file.temporaryURL = response.temporaryURL;
          file.fileType = 'image';
        } else {
          window.open(response.temporaryURL);
        }
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        const errorMessage = (isForVisualImage) ? 'Failed to get image file document' : 'Failed to download document';
        this.toastService.pop(TOAST_TYPE.error, errorMessage);
      });
  }

  updateChecklist($event, value){
    value.editingName  = false;
    value.name = value.tempName;
  }

  saveChecklist(){
    const checklistArray = [];
    const checklistDataObject: any = {
      id : this.taxStrategy.id,
      groupId: this.groupId,
    };
    const setUpChecklistObj = {
      checklists: this.checklist,
      id: this.setUpChecklistsGroupId,
      name: 'Setup'
    };
    checklistArray.push(setUpChecklistObj);
    const recurringChecklistObj = {
      checklists: this.recurringChecklists,
      id: this.recurringChecklistsGroupId,
      name: 'Recurring'
    };
    checklistArray.push(recurringChecklistObj);
    const eligibleCriteriaChecklistObj = {
      checklists: this.formatCriteriaForChecklists(),
      id: this.eligibilityCriteriaChecklistsGroupId,
      name: 'Eligibility Criteria'
    };
    checklistArray.push(eligibleCriteriaChecklistObj);

    checklistDataObject.sections = checklistArray;

    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.saveChecklist(this.org, this.user, this.taxStrategy.id, checklistDataObject)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.groupId = response.groupId;
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
      });
  }

  formatCriteriaForChecklists() {
    const data = [];
    if (this.taxStrategy.criteria && this.taxStrategy.criteria.length > 0) {
      _.each(this.taxStrategy.criteria, function(item){
        const obj = {
          id: item.id,
          name: item.text,
        };
        data.push(obj);
      });
    }
    return data;
  }

  stopEditingName($event, value){
    value.editingName = false;
    value.tempName = value.name;
  }

  removeCheckListValue(index, checkListValues){
    checkListValues.splice(index, 1);
  }

  editChecklist($event, index, value, type){
    if (type == 'Setup') {
      this.setEditChecklistValue(this.checklist, index, type);
    } else if (type == 'Recurring') {
      this.setEditChecklistValue(this.recurringChecklists, index, type);
    }
  }

  setEditChecklistValue(checkListValues, index, type) {
    _.each(checkListValues, function(checklistItem){
      checklistItem.editingName = false;
    });
    checkListValues[index].editingName = true;
    if (type == 'Setup') {
      checkListValues[index].tempName = this.checklist[index].name;
    } else if (type == 'Recurring') {
      checkListValues[index].tempName = this.recurringChecklists[index].name;
    }
  }

  onNewChecklistAdded($event, type){
    const obj = {
      id: uuid(),
      name: $event.newEntry,
      mandatory: false,
      editingName : false,
      description: $event.description
    };
    if (type == 'Setup') {
      this.checklist.push(obj);
    } else if (type == 'Recurring') {
      this.recurringChecklists.push(obj);
    }
  }

  initialiseChecklistSorting() {
    const base = this;
    setTimeout(() => {
      jQuery('.sortableChecklist').sortable({
        placeholder: 'ui-checklist-highlight',
        stop(event, ui) {
          const result = [];
          const itemsMarkup = jQuery(this).children();
          _.each(itemsMarkup, function(markup) {
            const id = markup.children[0].innerText;
            result.push(id);
          });
          const tempArray = [];
          _.each(result, function(id){
            tempArray.push(_.find(base.checklist, {id}));
          });
          base.checklist = tempArray;
        }
      });
      jQuery('.sortableChecklist').disableSelection();
    });
    setTimeout(() => {
      jQuery('.sortableRecurringChecklist').sortable({
        placeholder: 'ui-checklist-highlight',
        stop(event, ui) {
          const result = [];
          const itemsMarkup = jQuery(this).children();
          _.each(itemsMarkup, function(markup) {
            const id = markup.children[0].innerText;
            result.push(id);
          });
          const tempArray = [];
          _.each(result, function(id){
            tempArray.push(_.find(base.recurringChecklists, {id}));
          });
          base.recurringChecklists = tempArray;
        }
      });
      jQuery('.sortableRecurringChecklist').disableSelection();
    });
  }

  fileDropOver($event){
    this.loadingService.triggerLoadingEvent(true);
    this.uploader.uploadAll();
  }

  videoFileDropOver($event){
    this.loadingService.triggerLoadingEvent(true);
    this.videoUploader.uploadAll();
  }

  fileOverBase($event){
    this.hasBaseDropZoneOver = $event;
  }

  videoFileOverBase($event){
    this.hasBaseVideoDropZoneOver = $event;
  }

  uploaderUpdate() {
    const base = this;
    const docUrl: any = this.taxStrategyServices.getVideoDocumentServiceUrl(this.org, this.user);
    this.uploader = new FileUploader({
      url: docUrl,
      headers: [{
        name: 'Authorization',
        value: 'Bearer ' + Session.getToken()
      }]
    } as FileUploaderOptions);
    this.uploader.onAfterAddingFile = file => {
      file.withCredentials = false;
    };
  }

  videoUploaderUpdate() {
    const base = this;
    const docUrl: any = this.taxStrategyServices.getVideoDocumentServiceUrl(this.org, this.user);
    this.videoUploader = new FileUploader({
      url: docUrl,
      headers: [{
        name: 'Authorization',
        value: 'Bearer ' + Session.getToken()
      }]
    } as FileUploaderOptions);
    this.videoUploader.onAfterAddingFile = file => {
      file.withCredentials = false;
    };
  }

  buildItemForm() {
    const base = this;
    this.uploader.onBuildItemForm = (fileItem: any, form: any) => {
      const payload: any = {};
      payload.sourceType = (this.currentView === 'resources') ? 'tax_planning_resource' : 'tax_planning_firmCustomizations';
      payload.sourceID = this.newStrategyId;
      if (fileItem.file && fileItem.file.size){
        payload.fileSize = fileItem.file.size;
      }
      form.append('payload', JSON.stringify(payload));
    };
    this.uploader.onCompleteItem = (item, response, status, header) => {
      this.loadingService.triggerLoadingEvent(false);
      if (status === 200) {
        this.uploader.progress = 100;
        const document: any = JSON.parse(response);
        if (document) {
          const splitArray = document.name.split('.');
          if (base.isImage(splitArray[splitArray.length - 1])) {
            document.fileType = 'image';
          }
        }
        if (this.currentView === 'resources') {
          if (this.taxStrategy.resources.files){
            this.taxStrategy.resources.files.push(document);
          }
        } else if (this.currentView === 'firmCustomizations'){
          if (this.taxStrategy.firmCustomizations.files){
            this.taxStrategy.firmCustomizations.files.push(document);
          }
        } else if (this.currentView === 'overview'){
          if (this.taxStrategy.clientResourceFiles){
            this.taxStrategy.clientResourceFiles.push(document);
          }
        }
      } else {
        this.resetUploader();
        this.toastService.pop(TOAST_TYPE.error, 'Failed to upload document');
      }
    };
    this.uploader.onErrorItem = (item, response, status, headers) => {
      this.loadingService.triggerLoadingEvent(false);
    };
  }

  videoBuildItemForm() {
    const base = this;
    this.videoUploader.onBuildItemForm = (fileItem: any, form: any) => {
      const payload: any = {};
      payload.sourceType = 'TAX_STRATEGY_VIDEO';
      payload.sourceID = this.newStrategyId;
      if (fileItem.file && fileItem.file.size){
        payload.fileSize = fileItem.file.size;
      }
      form.append('payload', JSON.stringify(payload));
    };
    this.videoUploader.onCompleteItem = (item, response, status, header) => {
      this.loadingService.triggerLoadingEvent(false);
      if (status === 200) {
        this.videoUploader.progress = 100;
        const document: any = JSON.parse(response);
        if (document) {
          let obj = {};
          obj['id'] = document.id;
          obj['name'] = document.name;
          obj['link'] = document.viewDocContentURL;
          if (this.taxStrategy.resources.videos){
            this.taxStrategy.resources.videos.push(obj);
          }
        }
      } else {
        this.resetUploader('video');
        this.toastService.pop(TOAST_TYPE.error, 'Failed to upload document');
      }
    };
    this.videoUploader.onErrorItem = (item, response, status, headers) => {
      this.loadingService.triggerLoadingEvent(false);
    };
  }

  resetUploader(type?) {
    if (type && type == 'video') {
      this.videoUploader.queue.forEach(function(item) {
        item.remove();
      });
    } else {
      this.uploader.queue.forEach(function(item) {
        item.remove();
      });
    }
  }

  deleteFile(file) {
    if (this.currentView === 'resources') {
      this.taxStrategy.resources.files = this.taxStrategy.resources.files.filter((document, tempIndex) => {
        return document.id != file.id;
      });
    } else if (this.currentView === 'firmCustomizations'){
      this.taxStrategy.firmCustomizations.files = this.taxStrategy.firmCustomizations.files.filter((document, tempIndex) => {
        return document.id != file.id;
      });
    } else if (this.currentView === 'overview'){
      this.taxStrategy.clientResourceFiles = this.taxStrategy.clientResourceFiles.filter((document, tempIndex) => {
        return document.id != file.id;
      });
    }
  }

  onStrategyTypeSelect(event) {
    if (!_.isEmpty(event)) {
      this.taxStrategy.typeId = event.id;
    } else {
      this.taxStrategy.typeId = '';
    }
  }

  onStrategyRecurringSelect(event) {
    if (!_.isEmpty(event)) {
      this.taxStrategy.recurring = event.value;
    } else {
      this.taxStrategy.recurring = '';
    }
  }

  onStrategyAssociatedWithSelect(event) {
    if (!_.isEmpty(event)) {
      this.taxStrategy.associatedWith = event.id;
    } else {
      this.taxStrategy.associatedWith = '';
    }
  }

  onSubmit() {
    if (this.taxStrategy.name && this.taxStrategy.typeId) {
      if (this.taxStrategy.canSuggest && this.org != 'trialtaxplaniq' && this.org != 'taxplaniq' && this.org != 'meyertax') {
        this.reveal.suggesttion = true;
      } else {
        this.createOrUpdateStrategy();
      }
    } else {
      if (!this.taxStrategy.name) {
        this.toastService.pop(TOAST_TYPE.error, 'Please enter name');
      }else if (!this.taxStrategy.typeId) {
        this.toastService.pop(TOAST_TYPE.error, 'Please select a category');
      }
    }
  }

  getFormattedFilesArray(filesData) {
    const files = [];
    if (filesData && filesData.length > 0) {
      _.each(filesData, function(document) {
        const obj: any = {};
        obj.name = document.name;
        obj.id = document.id;
        obj.temporaryURL = document.temporaryURL;
        obj.doc_notes = document.notes ? document.notes : '';
        files.push(obj);
      });
    }
    return files;
  }

  removeEmptyValues(){
    this.taxStrategy.criteria = _.filter(this.taxStrategy.criteria, function(line){
      return !!line.text;
    });
    this.taxStrategy.opportunities = _.filter(this.taxStrategy.opportunities, function(line){
      return !!line.description;
    });
    this.taxStrategy.potentialRisks = _.filter(this.taxStrategy.potentialRisks, function(line){
      return !!line.description;
    });
    this.taxStrategy.clientTodos = _.filter(this.taxStrategy.clientTodos, function(line){
      return !!line.name;
    });
  }

  editStrategy(){
    this.stateService.addState(new State('STRATEGY_VIEW', this._router.url, null, null, null));
    this._router.navigate(['tax-planning', 'taxStrategies', this.taxStrategy.id, 'edit']);
  }

  addCustomTaxRate(){
    this.tempCustomRates.push({
      id: '',
      name: '',
      rate: '',
      formula: {
        actualValue: '',
        displayValue: '',
        displayValuesArray: [],
        actualValuesArray: []
      }
    });
    this.isCustomRateEdit = false;
    this.indexOfTempCustomRateObject = -1;
  }

  addOrUpdateCustomRate(obj){
    obj.customRate.formula = JSON.parse(obj.customRate.formula);
    if (obj.action == 'add'){
      this.taxStrategy.customTaxRates.push(obj.customRate);
      if (this.indexOfTempCustomRateObject != -1) {
        this.tempCustomRates.splice(this.indexOfTempCustomRateObject, 1);
      }
    } else {
      const index = _.findIndex(this.taxStrategy.customTaxRates, {id: obj.customRate.id});
      this.taxStrategy.customTaxRates[index] = _.cloneDeep(obj.customRate);
      this.taxStrategy = {...this.taxStrategy};
    }
  }

  appendCustomRate(customRate, index){
    if (customRate.name && customRate.rate){
      this.taxStrategy.customTaxRates.push(customRate);
      this.tempCustomRates.splice(index, 1);
      this.associatedWith = [...this.associatedWith, customRate];
    } else if (!customRate.name){
      this.toastService.pop(TOAST_TYPE.error, 'Enter name for custom rate');
    } else if (!customRate.rate){
      this.toastService.pop(TOAST_TYPE.error, 'Enter rate for custom rate');
    }
  }

  stopAdding(index){
    this.tempCustomRates.splice(index, 1);
  }

  stopEditing(customRate){
    customRate.isEditing = false;
  }

  editCustomRate(customRate){
    customRate.isEditing = true;
    customRate.tempName = customRate.name;
    customRate.tempRate = customRate.rate;
  }

  updateCustomRate(customRate){
    customRate.isEditing = false;
    customRate.name = customRate.tempName;
    customRate.rate = customRate.tempRate;
  }

  removeCustomRate(customRate, index){
    if (this.taxStrategy.associatedWith == customRate.id){
      this.toastService.pop(TOAST_TYPE.confirm, 'This rate is mapped to this strategy. Are you sure you want to delete?', {
        id: customRate.id
      });
      return;
    }
    this.taxStrategy.customTaxRates.splice(index, 1);
  }

  setApplicableTo(event){
    if (!_.isEmpty(event)) {
      this.taxStrategy.applicableTo = event.value;
    } else {
      this.taxStrategy.applicableTo = '';
    }
  }

  setComplexity(event){
    if (!_.isEmpty(event)) {
      this.taxStrategy.complexity = event.value;
    } else {
      this.taxStrategy.complexity = '';
    }
  }

  appendCriteria(){
    this.taxStrategy.criteria.push({order: this.taxStrategy.criteria.length + 1});
  }

  appendOpportunity(){
    this.taxStrategy.opportunities.push({
    });
  }

  appendPotentialRisk(){
    this.taxStrategy.potentialRisks.push({
    });
  }

  deleteCriteria(index){
    this.taxStrategy.criteria.splice(index, 1);
  }

  toggleDescription(value){
    value.showDescription = !value.showDescription;
  }

  deleteOpportunity(index){
    this.taxStrategy.opportunities.splice(index, 1);
  }

  deleteRisk(index){
    this.taxStrategy.potentialRisks.splice(index, 1);
  }

  deleteDocumentFile(file, index, type){
    if (type == 'clientResource') {
      this.taxStrategy.clientResourceFiles.splice(index, 1);
    } else if (type == 'resource') {
      this.taxStrategy.resources.files.splice(index, 1);
    } else if (type == 'firmCustomizations') {
      this.taxStrategy.firmCustomizations.files.splice(index, 1);
    }
  }

  deleteVideoDocumentFile(file, index){
    this.taxStrategy.resources.videos.splice(index, 1);
  }

  appendClientTodo(){
    this.taxStrategy.clientTodos.push({order: this.taxStrategy.clientTodos.length + 1});
  }

  deleteClientTodo(index){
    this.taxStrategy.clientTodos.splice(index, 1);
  }

  hideReveal(key){
    this.reveal[key] = false;
  }

  acceptOrDenySuggestedChanges(type) {
    if (type === 'accept') {
      this.createOrUpdateStrategy();
      this.suggestStrategyChanges();
    } else {
      this.createOrUpdateStrategy();
    }
  }

  stringifyFormulae(){
    const obj = _.cloneDeep(this.taxStrategy);
    obj.customTaxRates = obj.customTaxRates || [];
    _.each(obj.customTaxRates, function(rate){
      try{
        rate.formula = JSON.stringify(rate.formula);
      } catch (e){}
    });
    return obj;
  }

  createOrUpdateStrategy() {
    const base = this;
    this.loadingService.triggerLoadingEvent(true);
    const resources = {
      files: [],
      links: this.taxStrategy.resources.links,
      videos: this.taxStrategy.resources.videos
    };
    resources.files = this.getFormattedFilesArray(this.taxStrategy.resources.files || []);
    const customizations = {
      files: [],
      content: this.taxStrategy.firmCustomizations.content
    };
    customizations.files = this.getFormattedFilesArray(this.taxStrategy.firmCustomizations.files || []);
    this.removeEmptyValues();
    this.taxStrategy.resources = resources;
    this.taxStrategy.firmCustomizations = customizations;
    this.taxStrategy.clientResourceFiles = this.getFormattedFilesArray(this.taxStrategy.clientResourceFiles || []);
    this.taxStrategy['tags'] = this.selectedTagValues;
    this.saveChecklist();
    const requestObj = this.stringifyFormulae();
    this.taxStrategyServices.updateTaxStrategy(this.org, this.user, requestObj)
      .subscribe(success => {
        this.hideReveal('suggesttion');
        if (this.mode == 'edit') {
          this.toastService.pop(TOAST_TYPE.success, 'Tax Strategy Updated Successfully');
          if (this.stateService.states.length > 1){
            this.stateService.pop();
          }
          this._router.navigate(['tax-planning', 'taxStrategies', this.taxStrategy.id]);
        } else {
          this.toastService.pop(TOAST_TYPE.success, 'Tax Strategy Saved Successfully');
          this._router.navigate(['tax-planning', 'taxStrategies']);
        }
        this.loadingService.triggerLoadingEvent(false);
        if (this.displayType == 'popup'){
          this.switchBoard.onDisplayFloatingWindow.next({
            url: null
          });
          this.switchBoard.onTaxPlanningStrategyAction.next({
            action: 'create',
            strategy: success,
          });
        }

      }, error => {
        this.handleError(error);
      });
  }

  suggestStrategyChanges() {
    this.taxStrategyServices.suggestStrategyChanges(this.org, this.user, this.taxStrategyId).subscribe(response => {
      this.loadingService.triggerLoadingEvent(false);
    }, error => {
      this.handleError(error);
    });

  }

  openFormulaCalculator(tempCustomRate?, index?) {
    if (tempCustomRate) {
      this.tempCustomRateObject = tempCustomRate;
    }
    if (index != -1) {
      this.indexOfTempCustomRateObject = index;
    }
    this.reveal.fromulaCalculator = true;
  }

  showEditForCustomRate(rateObj) {
    const rate = _.cloneDeep(rateObj);
    if (rate && !rate.formula.displayValue) {
      rate.formula.displayValue = rate.rate;
      rate.formula.actualValue = rate.rate;
      rate.formula.displayValuesArray = (rate.formula.displayValuesArray) ? rate.formula.displayValuesArray : [];
      rate.formula.actualValuesArray = (rate.formula.actualValuesArray) ? rate.formula.actualValuesArray : [];
      rate.formula.displayValuesArray.push(rate.rate);
      rate.formula.actualValuesArray.push(rate.rate);
    }
    setTimeout(() => {
      this.openFormulaCalculator(rate, -1);
    });
  }

  setStrategyDeadline($event) {
    if ($event) {
      this.taxStrategy.deadline = $event;
    }
  }

  onTagSelect(tag) {
    if (!_.isEmpty(tag)) {
      this.selectedTagValues.push(tag);
      this.selectedTagValues = _.uniqBy(this.selectedTagValues, 'id');
      this.displayTags = false;
      setTimeout(() => {
        this.displayTags = true;
      });
    }
  }

  toggleAddTag(){
    this.isNewTagAdd = !this.isNewTagAdd;
  }

  addNewTagToFirmsList() {
    let requestObj = {};
    requestObj['label'] = this.tagName;
    this.loadingService.triggerLoadingEvent(true);
    this.taxStrategyServices.addNewTagNameToFirmsList(this.org, this.user, requestObj)
      .subscribe(success => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.success, 'Added successfully');
        this.taxStrategyServices.clearFirmTagsData();
        this.getFirmTagsForStrategy();
        this.tagName = '';
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed to add tag');
      });
  }

  removeSelectedTagValue(index) {
    this.selectedTagValues.splice(index, 1);
  }

  triggerRefreshOnUpdateTemplate() {
    this.showTemplates = false;
    this.getTaxStragegyData();
  }

  /* New UX changes */
  saveStrategy() {
    this.mode = 'add';
    this.onSubmit();
  }


  toggleAddChecklist(type){
    if (type == 'Setup') {
      this.setupChecklistName = '';
      this.setupChecklistDescription = '';
      this.isNewSetupChecklist = !this.isNewSetupChecklist;
    } else if (type == 'Recurring') {
      this.isNewRecurringChecklist = !this.isNewRecurringChecklist;
    }
  }

  addNewChecklist(type) {
    const obj = {
      id: uuid(),
      mandatory: false,
      editingName : false,
    };

    if (type == 'Setup') {
      obj['name'] = this.setupChecklistName;
      obj['description'] = this.setupChecklistDescription;
      this.checklist.push(obj);
    } else if (type == 'Recurring') {
      obj['name'] = this.recurringChecklistName;
      obj['description'] = this.recurringChecklistDescription;
      this.recurringChecklists.push(obj);
    }
    this.toggleAddChecklist(type);
  }

  goToPreviousSection() {
    this.currentSection = this.getSectionName('previous');
  }

  goToNextSection() {
    this.currentSection = this.getSectionName('next');
  }

  getSectionName(type) {
    let nextSecName = '';
    let previousSecName = '';
    if (this.currentSection == 'overview') {
      nextSecName = 'internal';
    } else if (this.currentSection == 'internal') {
      nextSecName = 'tasks';
      previousSecName = 'overview';
    } else if (this.currentSection == 'tasks') {
      nextSecName = 'review';
      previousSecName = 'internal';
    }  else if (this.currentSection == 'review') {
      previousSecName = 'tasks';
    }
    return (type == 'previous') ? previousSecName : nextSecName;
  }

  openEditStrategy() {
    this.reveal.editStrategy = true;
  }

  refreshStrategy() {
    this.reveal.editStrategy = false;
    this.getTaxStragegyData();
  }

  archiveStrategy() {
    const data = {
      key: 'status',
      value: 'Archived'
    };
    this.loadingService.triggerLoadingEvent(true);
    this.taxStrategyServices.archiveStrategy(this.org, this.user, this.taxStrategyId, data)
      .subscribe(success => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.success, 'Strategy Archived successfully');
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        const message = error.message ? error.message : `Failed to archive strategy`;
        try {
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, message);
        }
      });
  }

  private normalizeEnumValue(value: string): string {
    const spaced = (value || '').replace(/_/g, ' ').toLowerCase();
    return spaced.replace(/\b\w/g, (match: string) => match.toUpperCase());
  }

  getOverviewTaxStrategy() {
    const strategy = this.taxStrategy || {};
    const rules = strategy.rules || {};
    return {
      ...strategy,
      type: rules.aiQCategory || strategy.type,
      riskLevel: rules.aiQMinRisk || strategy.riskLevel
    };
  }
}

